import $ from "jquery";
import jQuery from "jquery";

// export for others scripts to use
window.$ = $;
window.jQuery = jQuery;

// set CSRF token for every AJAX request using jquery.cookie
require('jquery.cookie');
$.ajaxSetup({headers: {'X-XSRF-TOKEN': $.cookie('XSRF-TOKEN')}});

require('bootstrap-sass/assets/javascripts/bootstrap.js');

require('jquery.mmenu/dist/jquery.mmenu.js');
require('jquery.mmenu/dist/addons/fixedelements/jquery.mmenu.fixedelements.js');

require('swiper/dist/js/swiper.jquery.js');

require('jquery-ui');
require('jquery-ui/ui/widgets/datepicker.js');
require('blueimp-file-upload');

require('imagesloaded/imagesloaded.pkgd.js');
require('masonry-layout/dist/masonry.pkgd.js');

require('./jquery.plugin.min');
require('./jquery.maxlength.min');
require('./accordion');

const {initPhotoSwipeFromDOM} = require('./photoswipe-init');

const IBAN = require('iban');

$.datepicker.setDefaults({
    closeText: 'Sluiten',
    prevText: '←',
    nextText: '→',
    currentText: 'Vandaag',
    monthNames: ['januari', 'februari', 'maart', 'april', 'mei', 'juni',
        'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun',
        'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
    dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
    dayNamesShort: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
    dayNamesMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
    weekHeader: 'Wk',
    dateFormat: 'dd-mm-yy',
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
});

function initInputStatus($fields) {

    $('[name=amount]').on('keydown', function(evt) {
        var key = evt.charCode || evt.keyCode || 0;
        console.log(key);
        return (key == 8 ||
            key == 9 ||
            key == 46 ||
            (key >= 35 && key <= 40) ||
            (key >= 48 && key <= 57) ||
            (key >= 96 && key <= 105));
    });

    $fields.not('[name=iban]').not('[name=amount]').on('focus click', function () {
        $(this).closest('.input').addClass('focus');
        $(this).closest('.input').removeClass('error');
        $(this).closest('.input').find('.emailchecktext').remove();
    }).on('blur', function () {
        $(this).closest('.input').removeClass('focus');
    }).on('change keydown keyup init', function () {
        var $this = $(this);
        var val = $this.val();

        if (!val && $this.attr('type') == 'date') {
            val = $this.attr('value');
        }

        if($(this).attr('type') == 'checkbox' && $(this).closest('.input').hasClass('dropdown') && $(this).closest('.input').hasClass('multi')) {
            var valid = $(this).closest('.input').find(':checked').length > 0;
            $(this).closest('.input')
                .toggleClass('valid', valid)
                .toggleClass('value', valid);
        }
        else {
            $this.closest('.input')
                .toggleClass('valid', $this.is(':valid'))
                .toggleClass('value', !!val && (!$this.is('[type=checkbox]') || $this.is(':checked')));
        }

    }).trigger('init');
}

window.initInputStatus = initInputStatus;

function fixInputHeights() {
    var $popup = $('.popup-container .popup');

    if (!$popup.length) {
        return;
    }

    var popup_bottom = $popup.height() + $popup.offset().top;
    $popup.find('#request-form .label-input:last').addClass('last-label');
    $popup.find('.input .info').each(function () {
        var $this = $(this);
        var bottom = $this.height() + $this.parent().offset().top;

        $this.css({
            bottom: bottom > popup_bottom ? 30 : 'auto'
        });
    });
}


$(function () {

    $(window).on('resize', fixInputHeights);

    $('.input.dynamic-placeholder input').each(function () {
        $('<div>', {
            class: 'placeholder',
            html: $(this).attr('placeholder')
        }).insertAfter(this);
        $(this).attr('placeholder', '');
    });

    $('.input input').on('input', function () {
        $(this).closest('.input').toggleClass('value', !!$(this).val());
    });

    $("#mmenu").mmenu({
        offCanvas: {
            position: "right",
            zposition: "next"
        },
        navbar: false
    }).show();

    $('body').on('click touchstart', '.input.dropdown', function (e) {
        if ($(e.target).is('input, .info')) {
            return;
        }
        $(this).prev('.input').addClass('focus');
        $(this).addClass('active');
    });

    $('body').on('click touchstart', function (e) {
        if ($(e.target).closest('.input.dropdown').length == 0) {
            $('.input.dropdown').removeClass('active');
            $('.input.dropdown').prev('.input').removeClass('focus');

        }
    });

    $(document).on('click', '.confirm-button', function () {
        $('.input.dropdown').removeClass('active');
    });

    $('body').on('change', '.input.dropdown:not(.multi) input', function () {
        $(this).closest('.input').removeClass('active').find(' > span, > .field > span').html($(this).next('label').html());
    });

    $('body').on('change', '.input.dropdown.multi input', function () {
        var $input = $(this).closest('.input');

        var labels = [];

        $input.find('input:checked').each(function () {
            labels.push(
                $(this).next('label').html().trim()
            );
        });

        if (labels.length == 0) {
            labels.push('&nbsp;')
        }
        $(this).next('label').html();

        $input.find(' > span, > .field > span').html(labels.join(', '));
    });

    $('.projects .filter .input.dropdown input, .search-results .input.dropdown input').on('change', function (e) {
        e.stopImmediatePropagation();
        window.location.href = $(this).val();
    });

    function initFileFields() {
        function initFileUpload() {
            var $this = $(this);
            var $dropzone = $this.closest('.dropzone');
            var $file = $this.prev();
            var $name = $file.prev();
            var $progress = $this.closest('.fileinput-button').find('.progress-bar');
            var $desc = $this.closest('.input').find('.desc');
            var $btn = $this.closest('.progress-button');
            var $filebutton = $this.closest('.input').find('.file-button');
            var $filename = $filebutton.find('.name');
            var $remove = $filebutton.find('.remove');

            $remove.on('click', function () {
                $file.val('');
                $name.val('');
                $filebutton.fadeOut(300, function () {
                    $desc.show();
                    $progress.html('').width(0);
                    $btn.fadeIn(300);
                });
            });

            $(this).fileupload({
                maxNumberOfFiles: 1,
                dropZone: $dropzone,
                url: $this.data('url'),
                paramName: 'file',
                done: function (e, r) {

                    $file.val(r.result.file);
                    $name.val(r.result.name);

                    $file.trigger('change');
                    $name.trigger('change');

                    $btn.fadeOut(600, function () {
                        $filename.html(r.result.name);
                        $filebutton.fadeIn(300);
                    });
                },
                progressall: function (e, data) {


                    var progress = parseInt(data.loaded / data.total * 100, 10);
                    $progress.show().html('<div>' + progress + '%</div>').css('width', progress + '%');
                },
                add: function (e, data) {
                    var uploadfile = $(this);
                    if ($dropzone.data('url') == null || $dropzone.data('url').length == 0) {
                        if (data.autoUpload || (data.autoUpload !== false &&
                            uploadfile.fileupload('option', 'autoUpload'))) {
                            $desc.hide();

                            data.process().done(function () {
                                data.submit();
                            });
                        }
                        return false;
                    }


                    resetFileUpoadPopup($dropzone.data('url'));
                    $('.popup-yes').on('click', function () {
                        if ($(this).closest('.popup-redirect').hasClass('checked')) {
                            $('.file_check_popup').removeClass('active');
                            data.submit();
                        }
                    });
                    $('.popup-no').on('click', function () {
                        $('.file_check_popup').removeClass('active');
                        return false;
                    });
                    // if (data.autoUpload || (data.autoUpload !== false &&
                    //     uploadfile.fileupload('option', 'autoUpload'))) {
                    //     $desc.hide();
                    //
                    //     data.process().done(function () {
                    //         data.submit();
                    //     });
                    // }
                }
            });
        }

        $('.popup .file-upload').each(initFileUpload);

        $('.file_add').on('click', function () {
            var clone = $(this).next().clone();
            clone.find('[data-name]').each(function () {
                $(this).attr('name', $(this).data('name'));
            });
            initFileUpload.call(clone.find('input.file-upload'));
            clone.show().insertBefore(this);
        });

        $('.popup .files').on('click', '.input svg.delete', function () {
            $(this).closest('.input').remove();
        });

        $('.euros input').on('blur', function () {
            var $this = $(this);
            var min = $this.data('min');

            $this.val($this.val().replace(/\D/g, ''));

            if (!min) {
                return;
            }

            if (parseInt($this.val()) < min) {
                $this.closest('.input').addClass('error').removeClass('valid value');
                $this.val('');
            }
        }).on('keydown', function (e) {
            if (e.key == ',' || e.key == '.') {
                e.preventDefault();
                return false;
            }
        });

        $('label.view-info').mouseover(function () {
            $('.input.focus').removeClass('focus');
        });

        setTimeout(function () {
            fixInputHeights();
        }, 500);
    }

    window.openPopup = function (url, lock) {
        var mmenu = $("#mmenu").data("mmenu");
        mmenu.close();

        if(lock) {
            $('.overlay').addClass('lock-popup');
        } else {
            $('.overlay').removeClass('lock-popup');
        }

        $('.overlay, .overlay-background').fadeIn(0, function () {
            $('.overlay, .overlay-background').scrollTop(0);
        });

        $('.overlay').load(url, function () {
            setTimeout(function () {
                $('body').addClass('active-overlay');
                $("#nav-icon").removeAttr('aria-label').attr('aria-label', 'Terug naar het menu');
                initFileFields();
                initTextareas();
                initIbanField();
                var $fields = $('#request-form').find('textarea, input, select');
                initInputStatus($fields);
                $('.popup').find('input[type=date], input.date-p').attr('type', 'text').datepicker({
                    dateFormat: "dd-mm-yy",
                    onClose: function (dateText, inst) {
                        $(this).datepicker('option', 'dateFormat', 'dd-mm-yy');
                    }
                }).closest('.field').addClass('date');

                $('input[name=start_date]').datepicker('option', 'onSelect', function () {
                    $('input[name=end_date]').datepicker('option', 'minDate', $(this).datepicker('getDate'));
                });
            }, 300);
        });
    };

    function closeOverlay() {

        $('body').removeClass('active-overlay');
        setTimeout(function () {
            $('.overlay, .overlay-background').hide();
        }, 500);
    }

    ////////////////////////////////////////////////
    // temporary fix for accessibility voice over //
    // menus were not closable                    //
    $("#nav-icon").click(function() {
        if ($("#mmenu").hasClass("mm-opened")) {
            $("#mmenu").data("mmenu").close();
            $("#nav-icon").removeAttr('aria-label').attr('aria-label', 'Open het menu');
            $("div.mm-page").removeAttr('aria-hidden').attr('aria-hidden', 'false');
        } else {
            $("#nav-icon").removeAttr('aria-label').attr('aria-label', 'Sluit het menu'); 
            $("div.mm-page").removeAttr('aria-hidden').attr('aria-hidden', 'true');
        }
        
        closeOverlay();
    })
    /////////////////////////////////////////////////

    $('body').on('click', '[data-popup]', function (e) {
        if ($(this).hasClass('cm-button-disabled')) {
            return;
        }

        e.preventDefault();
        let form = $(this).closest('form.popup-parameters');
        let url = $(this).data('popup');
        let lock = $(this).data('lock-popup');

        if (form) {
            url += '?' + form.serialize();
        }

        window.openPopup(url, lock);
    }).on('click', '.overlay', function (e) {

        var $target = $(e.target);

        if ($target.data('close-popup') !== undefined) {
            closeOverlay();
            return;
        }

        if ($target.closest('.overlay').hasClass('lock-popup')) {
            return;
        }
        if ($target.closest('.popup-container').length == 1) {
            return;
        }
        if ($target.closest('.file_check_holder').length == 1) {
            return;
        }
        if ($target.closest('.file_check_popup').length == 1) {
            $('.file_check_popup').removeClass('active');
            return;
        }

        if ($target.closest('.save-bar').length > 0) {
            return;
        }

        closeOverlay();
    }).on('click', '.save-bar .cancel', function () {
        $('body .overlay').click();
    }).on('click', '.save-bar .save', function () {
        var $form = $('form#request-form');


        $.post($form.attr('action'), $form.serializeArray(), function (r) {
            if (r.redirect) {
                location.href = r.redirect;
            }

            $('.circle-progress[data-type="' + r.type + '"').data('formProgress', r.progress)
                .closest('.form-progress').toggleClass('done', r.progress == 100);

            renderFormProgress();

            $('#submit-request-btn').toggleClass('is-incomplete', r.all_progress != 100);
        });
        closeOverlay();
    });

    $('#submit-request-btn').on('click', function () {
        if ($(this).is('.has-pending, .is-incomplete')) {
            return false;
        }

        if ($(this).hasClass('first')) {
            return;
        }

        var $form = $('#request-form');
        var href = $(this).attr('href');

        var fields = $form.serializeArray();
        var $emailcheck, $emailconfcheck, $emailconftext;

        $form.find('.emailchecktext').remove();
        $emailcheck = $('input[name=email]');
        $emailconfcheck = $('input[name=email_confirmation]');
        if ($emailcheck.val() != $emailconfcheck.val()) {
            $emailconfcheck.closest('.input').removeClass('value valid').addClass('error');
            $emailconftext = '<span class="emailchecktext">De e-mailadressen komen niet overeen</span>';
            $emailconfcheck.closest('.field').append($emailconftext);
            return false;
        }


        $.post($form.attr('action'), fields, function (r) {
            if (r.progress == 100) {
                $('.profile').hide();
                $('.sending').show();

                setTimeout(function () {
                    $('.sending .progress .progress-bar').css('width', '100%');

                    $.post(href);

                    setTimeout(function () {
                        $('.sending').hide();
                        $('.sent').show();
                    }, 2000);
                }, 500);
            } else {
                var $required = $form.find('[required]');
                $required.removeClass('error');
                $required.each(function () {
                    if ($(this).attr('type') == 'checkbox' && !$(this).is(':checked')) {
                        $(this).addClass('error');
                    }

                    if ($(this).attr('type') != 'checkbox' && $(this).val() == '') {
                        $(this).closest('.input').addClass('error');
                    }
                });

                var $email_confirm = $form.find('[name="email_confirmation"]');

                if ($email_confirm.length > 0 && $email_confirm.val() !== '') {
                    var $email = $form.find('[name="email"]');

                    if ($email_confirm.val() != $email.val()) {
                        $email.closest('.input').addClass('error').removeClass('value');
                        $email_confirm.closest('.input').addClass('error').removeClass('value');
                    } else {
                        $email.closest('.input').removeClass('error');
                        $email_confirm.closest('.input').removeClass('error');
                    }
                }
            }
        });

        return false;
    });

    initPhotoSwipeFromDOM('.block.gallery');

    $('#terms_of_use_request').on('click', function () {
        var $this = $(this);
        var $checkbox = $this.closest('.questions-container-terms').find('#terms');
        var $status = $checkbox.is(':checked');
        if (!$status) {
            $checkbox.addClass('error');
            return false;
        }
        var $checkbox = $this.closest('.questions-container-terms').find('#privacy');
        var $status = $checkbox.is(':checked');
        if (!$status) {
            $checkbox.addClass('error');
            return false;
        }
        goToNextQuestion($this);


    });

    function goToNextQuestion($this) {
        var $questions = $this.closest('.questions');
        var $this_q = $this.closest('.question');
        var $next_q = $this_q.next('.question');

        function transition() {
            $next_q.addClass('active');

            $questions.css('left', function () {
                var index = $this.closest('.question').index() + 1;
                $questions.trigger('change', index);
                return (index * -100) + '%';
            });

            setTimeout(function () {
                $this_q.removeClass('active');
                $next_q.find('.input input').focus();
            }, 500);
        }

        var $validate_form = $this.closest('form.validate-each');
        var $input = $this_q.find('input, select, textarea');
        if (!$validate_form.length || !$input.length) {
            transition();
            return;
        }

        $this_q.find('.error').html('');
        $validate_form.addClass('validating');
        $.post($validate_form.attr('action'), $validate_form.serializeArray(), transition)
            .fail(function (r) {
                var name = $input.attr('name');
                var error = r.responseJSON[name.replace(/(.*)_confirmation$/, '$1')];

                if ($.isArray(error))
                    error = error[0];

                if (error === undefined ||
                    (error == 'De ingevulde wachtwoorden komen niet overeen.' && name == 'password')) {
                    transition();
                    return;
                }

                $this_q.find('.error').html(error);
            })
            .always(function () {
                $validate_form.removeClass('validating');
            });
    }

    function goToPrevQuestion($this) {
        var $questions = $this.closest('.questions');
        var $this_q = $this.closest('.question');
        var $prev_q = $this_q.prev('.question');

        $prev_q.addClass('active');

        $questions.css('left', function () {
            var index = $this.closest('.question').index() - 1;
            $questions.trigger('change', index);
            return (index * -100) + '%';
        });

        setTimeout(function () {
            $this_q.removeClass('active');
            $prev_q.find('.input input').focus();
        }, 500);
    }

    $('.question .answers .buttons > *').on('click', function () {
        var $this = $(this);

        if ($this.hasClass('back')) {
            history.back();
        } else if ($this.hasClass('right') || $this.hasClass('set-val')) {
            $.get('ajax/question', {question_id: $this.data('question-id')});
            goToNextQuestion($this);
        } else {
            $this.closest('.question').addClass('failed');
        }

        if ($this.hasClass('set-val')) {
            $this.closest('.buttons').find('input[type=hidden]').val($this.data('val'));
        }
    });

    $('.question .input .button').on('click', function () {
        var $this = $(this);

        if (!$this.hasClass('inactive')) {
            goToNextQuestion($this);
        }

    });

    $('.question .input input').on('keyup', function (e) {
        if ($(this).val() == '') {
            $(this).closest('.input').find('.button').addClass('inactive');
            $(this).closest('.input').find('button.button').attr('disabled', true);
        } else {
            $(this).closest('.input').find('.button').removeClass('inactive');
            $(this).closest('.input').find('button.button').attr('disabled', false);
        }
    });

    $('.question .input .fake-radios input[type=radio]').on('change', function () {
        $(this).closest('.input').find('.button').removeClass('inactive');
        $(this).closest('.input').find('button.button').attr('disabled', false);
    });

    $('.question .input input').on('keydown', function (e) {
        if (e.keyCode == 13 || e.keyCode == 9) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            $(this).closest('.input').find('.button').trigger('click');
        }
    });

    if ($('.questions').length) {
        var $counter = $('.counter');
        var length = $('.questions .question').length;
        $counter.find('.count').html(1);
        $counter.find('.total').html(length);
        $counter.show();

        $('.questions').on('change', function (e, index) {
            if (index !== undefined) {
                $counter.find('.count').html(Math.min(length, index + 1));
            }
        });
    }

    function resetFixedTop($this) {
        $this.css({
            position: '',
            width: '',
            top: ''
        });

        return $this;
    }

    function initFixOffsets() {
        resetFixedTop($('.scroll-title, .about .menu > ul')).each(function () {
            var $this = $(this);
            var top = $this.offset().top;
            $this.data('top', top);
            $this.data('max', top + $this.closest('.row, .menu').height());
        });

        fixTops();
    }

    initFixOffsets();

    function fixTops() {
        if ($(window).width() < 992) {
            return;
        }

        var scroll_top = $(window).scrollTop();

        $('.scroll-title, .about .menu > ul').each(function () {
            var $this = $(this);
            if ($this.data('top') - scroll_top < 0) {
                var h = $this.outerHeight();
                $this.css({
                    position: 'fixed',
                    width: $this.width(),
                    top: -Math.max(0, (scroll_top + h - $this.data('max')))
                });
            } else {
                resetFixedTop($this);
            }
        });
    }

    $(window).on('load resize', initFixOffsets);
    $(window).on('scroll', fixTops);

    //$('.form-progress').eq(2).trigger('click');

    function search(e) {
        $(e.target).closest('.search').find('form').submit();
    }

    $('header, #mmenu').find('.search')
        .on('click', function (e) {
            if (!$(e.target).is('input')) {
                search(e);
            }
        }).find('input').keypress(function (e) {
        if (e.which == 13) {
            search(e);
        }
    });

    $('#archive-filter').on('change', function () {
        var val = $(this).find('input[name=show]:checked').val();

        $('.news-list > .list-item').each(function () {
            var $this = $(this);

            if (val != 0) {
                $this.toggle($this.data('year') == val);
            } else {
                $this.toggle($(this).data('recent') == 1);
            }
        });
    }).trigger('change');

    $('form.ajax').on('submit', function () {
        var $this = $(this);

        $this.removeClass('success fail');
        $this.find('span.error').remove();

        $.ajax({
            url: $this.attr('action'),
            method: $this.attr('method'),
            data: $this.serializeArray()
        }).done(function () {
            $this.addClass('success');
            $this.find('button').after(`<span class="success">Uw bericht is verzonden!</span>`);
        }).fail(function (jqXHR) {
            if (jqXHR.responseJSON) {
               for (let x in jqXHR.responseJSON) {
                 $this.find('[name=' + x + ']').addClass('error').after(`<span class="error">${jqXHR.responseJSON[x].toString()}</span>`);
               }
            }
            $this.addClass('fail');
        });

        return false;
    });

    function initTextareas() {
        $('textarea[maxlength]').each(function () {
            var $this = $(this);

            $this.maxlength({
                max: $this.attr('maxlength'),
                feedbackTarget: $this.closest('.input').prev('.input').find('label .count'),
                feedbackText: '{c}/{m} tekens'
            });
        });
    }

    initTextareas();


    function initIbanField() {
        $('input[name=iban]').on('blur', function () {
            var $this = $(this);
            var valid = IBAN.isValid($this.val());
            $this.closest('.input').toggleClass('valid', valid);
            $this.closest('.input').toggleClass('value', valid);
            $this.closest('.input').toggleClass('error', !valid);
        });
    }

    initIbanField();

    $('form.grecaptcha').on('submit', function (e) {
        e.preventDefault();

        var $this = $(this);
        const google_key =  $this.data('grecaptcha');
        $this.removeClass('success fail');

        grecaptcha.ready(function() {
            grecaptcha.execute(google_key, {action: 'submit'}).then(function(token) {
                let data = $this.serializeArray();
                data.push({name: 'token', value: token});

                $.ajax({
                    url: $this.attr('action'),
                    method: $this.attr('method'),
                    data: data
                }).done(function () {
                    $this.addClass('success');
                }).fail(function () {
                    $this.addClass('fail');
                });
            });
        });

        return false;
    });

});

$(function () {
    $('.scroll-to-my-top').on('click', function () {
        $("html, body").animate({
            scrollTop: $(this).offset().top
        });
    });

    if ($('.projects').length) {
        $(function () {
            var searchTimeout;

            var $discipline = $('.projects input[name=discipline]').on('change', function () {
                searchFilter();
            });

            $('.subfilter .search input').on('keyup', function () {
                clearTimeout(searchTimeout);
                var search = $(this).val();
                searchTimeout = setTimeout(function () {
                    searchFilter();
                }, 300);
            });

            function searchFilter() {
                var search = $('.subfilter .search input').val();
                var discipline = $discipline.filter(':checked').val();

                var $projectList = $('.project-list');
                var regex = new RegExp(search, 'i');

                $projectList.find('.project-list-item').each(function () {
                    var organization = $(this).data('organization') + '';
                    var title = $(this).data('title') + '';

                    $(this).show();

                    var visible = ($(this).data('discipline') == discipline || discipline == 'all');

                    $(this).toggle(visible);

                    if (search == '') {
                        $(this).find('.organization').html($(this).data('organization'));
                        $(this).find('.title').html($(this).data('title'));
                    }
                    else if (organization.match(regex) || title.match(regex)) {
                        organization = organization.replace(regex, '<span class="search-result">' + search + '</span>');
                        title = title.replace(regex, '<span class="search-result">' + search + '</span>');

                        $(this).find('.organization').html(organization);
                        $(this).find('.title').html(title);
                    }
                    else {
                        $(this).hide();
                        $(this).find('.organization').html($(this).data('organization'));
                        $(this).find('.title').html($(this).data('title'));
                    }
                });


                $('.project-list-item').each(function () {
                });
            }


        });
    }
});

function renderFormProgress() {
    $('[data-form-progress]').each(function () {

        $(this).toggleClass('empty', !$(this).data('form-progress'));

        var transform_styles = ['-webkit-transform', '-ms-transform', 'transform'];
        var $this = $(this);
        var rotation = $this.data('form-progress') / 100 * 180;

        for (let i in transform_styles) {
            $(this).find('.circle .fill, .circle .mask.full').css(transform_styles[i], 'rotate(' + rotation + 'deg)');
            $(this).find('.circle .fill.fix').css(transform_styles[i], 'rotate(' + (rotation * 2) + 'deg)');
        }
    });
}

$(window).on('load', function () {

    // cookie aria labels to dutch
    $(".cc-type-opt-in").find("a[aria-label='allow cookies']").attr('aria-label', 'Ik accepteer de cookies')
    $(".cc-type-opt-in").find("a[aria-label='dismiss cookie message']").attr('aria-label', 'Ik weiger de cookies')

    $('[data-progress]').each(function () {

        var $this = $(this);
        var progress = $this.data('progress') + '%';

        $this.find('.fill').animate({
            width: progress
        }, {
            duration: 1500,
            //easing: 'ease',
            step: function (now, fx) {
                $this.find('.fill > div').html(Math.round(now) + '%')
            }
        });
    });

    $('.projects .triple').each(function () {
        var maxHeight = 0;

        $(this).find('> div').each(function () {
            if ($(this).innerHeight() > maxHeight) {
                maxHeight = $(this).innerHeight();
            }
        });

        $(this).find('> div').each(function () {
            $(this).height(maxHeight);
        });

    });

    function fixNewsItemHeights() {
        $('.news-item').each(function () {
            var $this = $(this);
            var img_height = $this.find('img').outerHeight();
            $(this).height(img_height + $this.find('h3').outerHeight());
            let top = img_height;
            if ($(this).hasClass('highlight-item')) {
                top = 220
            }

            $(this).find('.info').css({
                top: top
            }).addClass('loaded');
        });
    }

    var $masonry;

    function setMasonry() {

        if ($(window).width() < 768) {
            if ($masonry) {
                $masonry.masonry().masonry('destroy');
            }
        } else {
            $masonry = $('.grid').masonry({
                itemSelector: '.grid-item'
            });
        }

    }

    $('.grid').imagesLoaded(function () {
        setMasonry();
        fixNewsItemHeights();
        $(window).on('resize', setMasonry);
        $(window).on('resize', fixNewsItemHeights);
    });

    $('.mijn .questions-container .question > .container').css('min-height',
        $(window).height() - $('.breadcrumb').outerHeight() - $('header').outerHeight()
    );

    renderFormProgress();

    $('.delete-request').on('click', function (e) {
        e.preventDefault();

        if (confirm('Weet u zeker dat u deze aanvraag wilt verwijderen?')) {
            window.location.href = $(this).data('url');
        }
    });


    $('body a.share').on('click', function () {
        var url = $(this).attr('href');
        var type = $(this).data('type');

        var config = {
            facebook: {
                w: 655,
                h: 360,
                prefix: 'http://www.facebook.com/sharer.php?u='
            },
            twitter: {
                w: 655,
                h: 444,
                prefix: 'https://twitter.com/share?url='
            },
            google: {
                w: 480,
                h: 600,
                prefix: 'https://plus.google.com/share?url='
            },
            linkedin: {
                w: 480,
                h: 600,
                prefix: 'https://www.linkedin.com/cws/share?url='
            }
        };

        var c = config[type];
        window.open(c.prefix + url, 'sharer', 'toolbar=0,status=0,width=' + c.w + ',height=' + c.h);

        return false;
    });


    var $form = $('form#fonds21-test');

    $('input[name=category_id]').on('change', function () {
        $form.find('input[type=submit]').prop('disabled', false);
    });

    $form.on('submit', function () {
        var val = $('input[name=category_id]:checked').val();

        if (!val) {
            return false;
        }

        location.href = location.href + '/' + val;
        return false;
    });
});

$('body').on('click', '.project-list .more-info', function () {
    $(this).closest('.project-list-item').toggleClass('more');
});

$(function () {
    new Swiper('.home-slides .swiper-container', {
        loop: true,
        autoplay: 4000,
        speed: 800,
        effect: 'fade',
        onlyExternal: true,
        pagination: '.swiper-pagination'
    });
});

$(function () {
    new Swiper('.home-projects .swiper-container', {
        loop: true,
        slidesPerView: 'auto',
        // Navigation arrows
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev'
    });
});

$(function () {
    var $buttons = $('.proximity-button');

    $(window).on('mousemove', function (e) {
        $buttons.each(function () {
            var $this = $(this);

            var x = e.pageX - $this.offset().left;
            var y = e.pageY - $this.offset().top;

            $this.toggleClass('active', x * x + y * y < 200 * 200);
        });
    }).on('mouseleave', function () {
        $buttons.removeClass('active');
    });
});

$(function () {
    $('.notification').each(function () {
        var $notification = $(this);

        function close() {
            $notification.addClass('closing');
            setTimeout(function () {
                $notification.remove();
            }, 800);
        }

        $notification.find('svg, a').on('click', function () {
            close();
        });

        setTimeout(function () {
            $notification.removeClass('closed');
            setTimeout(close, 10000);
        }, 2000);
    });
});

$(function () {
    var $list = $('.project-list');

    $('.projects input[name=year]').on('change', function () {
        var v = $(this).val();

        $.get(v)
            .then(function (r) {
                $list.html(
                    $(r).find('.project-list').children()
                );

                history.replaceState({}, "", v);
            });
    });
});


function resetFileUpoadPopup($text) {
    var $popup = $('.file_check_popup');
    $popup.find('#checkbox-fileupload').prop('checked', false);
    $popup.find('.popup-redirect').removeClass('checked');
    $popup.addClass('active');
    $popup.find('.content').text($text);
}

window.toggleCheck = function () {
    $('.file_check_popup .popup-redirect').toggleClass('checked');
}

window.timelineAnimation = function ($value) {
    $value.find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
    setTimeout(function () {
        timelineAnimation($value.next('.cd-timeline-block'));
    }, 150);
};
var offset = 0.8;
$(window).on('scroll load', function () {

    var $first = $('#cd-timeline').find('.cd-timeline-block:first');
    if ($first.length != 0) {
        if ($first.offset().top <= $(window).scrollTop() + $(window).height() * offset && $first.find('.cd-timeline-img').hasClass('is-hidden')) {
            timelineAnimation($first);
            $first.next('.cd-timeline-block').addClass('test');
        }
    }
});
$(function () {
    $('.request-send-close').on('click', function () {

        $(this).closest('.request-send').fadeOut();
    });


    $('#terms').change('input', function () {
        $(this).removeClass('error');
    });
    $('#privacy').change('input', function () {
        $(this).removeClass('error');
    });


    var $inputzip = $('input[name=zip]');
    var $inputzip_visit = $('input[name=zip_visit]');
    if ($inputzip.length != 0) {
        zipcodeChecker($inputzip);
    }
    if ($inputzip_visit.length != 0) {
        zipcodeChecker($inputzip_visit);
    }

    function zipcodeChecker($value) {
        $value.val(postcodeValidatie($value.val()))
            .on('input', function () {
                var $zipcode = $(this);
                $zipcode.val(postcodeValidatie($zipcode.val()));
            }).attr('maxlength', '7');
    }


    function postcodeValidatie(val) {
        let match = val.toUpperCase().match(/^([1-9][0-9]{0,3})([\s])?([A-Z]{1,2})?/);

        if (!match) {
            return '';
        }

        let res = match[1];

        if (match[3]) {
            res += ' ' + match[3];
        } else if (match[2]) {
            res += ' ';
        }

        return res;
    }

    $('.blocks').find('table').each(function () {
        $(this).wrap('<div class="table-responsive"></div>')
    })
});

$('[data-scroll-to]').on('click', (event) => {
    const elem = document.querySelector(event.currentTarget.dataset.scrollTo);
    smoothScroll(elem.getBoundingClientRect().y)
})

function smoothScroll(position) {
    // Wait for repaint to finish before scrolling
    setTimeout(() => {
        window.scrollTo({
            top: position,
            behavior: 'smooth'
        });
    }, null)
}

// Scroll hijack
$('[data-js-hijack]').on('click', (event) => {
    window.addEventListener("beforeunload", () => {
        localStorage.setItem("scrollPosition", window.scrollY);
    });
});

if(localStorage.getItem('scrollPosition')) {
    window.scrollTo({top:localStorage.getItem("scrollPosition")});
    localStorage.removeItem('scrollPosition')
}

// Quickcheck 
$('.question__button').on('click', function(){
    const answer = $(this).val();
    const correctAnswer = $(this).parent().attr('data-answer');
    const incorrectMessage = $(this).parent().attr('data-incorrect-message');
    const parentQuestion = $(this).closest('.question__item')
    parentQuestion.removeClass('current');
    if(answer == correctAnswer) {
        parentQuestion.next().addClass('current');
    } else {
        const $wrong = $('.wrong');
        if (incorrectMessage !== '') {
            const message = atob(incorrectMessage);
            $wrong.find('.message').html(message);
        }
        $wrong.addClass('current');
    }
});

const image1 = $('.home-header__interaction--thumb:first-of-type');
const image2 = $('.home-header__interaction--thumb:nth-of-type(2)');
const image3 = $('.home-header__interaction--thumb:nth-of-type(3)');
const headerTitle = $('.home-header__interaction--title');

$('.project-display__filter--item').on('click', function(){
    const filterId = $(this).attr('id');
    $('.swiper-slide').each(function(index, value){
        if($(value).attr('data-id') == filterId) {
            $(value).show();
        } else {
            $(value).hide();
        }
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/index.js